export default {
  methods: {
    getInstitutions() {
      return this.axios.get('/api/v1/hosting-institutions/all');
    },
    getScientificDomains() {
      return this.axios.get('/api/v1/scientific-domains');
    },
    getScientificSubdomains() {
      return this.axios.get('/api/v1/scientific-subdomains');
    },
    getStructureTypes() {
      return this.axios.get('/api/v1/structure-types');
    },
    getCategories() {
      return this.axios.get('/api/v1/categories');
    },
    getSubCategories() {
      return this.axios.get('/api/v1/subcategories');
    },
    getAccessModes() {
      return this.axios.get('/api/v1/access-modes');
    },
    getAccessTypes() {
      return this.axios.get('/api/v1/access-types');
    },
    getOperationalModes() {
      return this.axios.get('/api/v1/operational-modes');
    },
    getTargets() {
      return this.axios.get('/api/v1/targets');
    },
    getAreasOfActivities() {
      return this.axios.get('api/v1/areas-of-activity');
    },
    getEcosystemStakeholderProfile() {
      return this.axios.get('api/v1/ecosystem-stakeholder-profile');
    },
  },
};
